import { html } from '@shared/utils/rendering/html';
import { useState, useEffect } from 'preact/hooks';
import {
    createSubcomponentColumns,
    subcomponentPaginationConfig,
    subcomponentSortingConfig,
} from '../../../../../configs/tables/dashboard/subcomponents-table.config';
import subcomponentActions from './subcomponent-actions';
import SubcomponentCollapseInner from './subcomponent-collapse-inner';
import Table from '@shared/components/tables';

const SubcomponentSection = ({ details, filterRef, filters, isSecondPeriod }) => {
    const [config, setConfig] = useState({
        columns: createSubcomponentColumns(isSecondPeriod),
        filters: {
            sorting: subcomponentSortingConfig,
            pagination: subcomponentPaginationConfig,
        },
        actions: subcomponentActions,
        collapse: {
            enabled: true,
            render: (rowData) => SubcomponentCollapseInner(rowData, filters),
        },
    });

    // Update columns when isSecondPeriod changes
    useEffect(() => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            columns: createSubcomponentColumns(isSecondPeriod),
        }));
    }, [isSecondPeriod]);

    return html`
        <${Table}
            config=${config}
            data=${{
                isLoading: false,
                rows: details?.subcomponents,
                total: details?.subcomponents.length,
            }}
            overrideFilterRef=${filterRef}
        />
    `;
};

export default SubcomponentSection;
